import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { AppointmentListingViewModel } from '../../../../models/appointment';
import { AppointmentTypes, AppointmentState } from '../../../../common/enums';

@Component
class AgendaEventItem extends Vue {
  dtMenu: boolean;
  event: AppointmentListingViewModel;
  allowResizable: boolean;
  routeMeta: { [key: string]: boolean }
  canUpdate: { event: boolean; appointment: boolean; }
  canRemove: { event: boolean; appointment: boolean; }
  /**
   *
   */
  constructor() {
    super();
    this.dtMenu = false;

  }
  get resizable(): string {
    return this.allowResizable ? 'fc-resizable' : '';
  }
  get style(): { backgroundColor: string, borderColor: string } {
    return {
      backgroundColor: this.event.backgroundColor,
      borderColor: this.event.borderColor
    }
  }
  get className(): string {
    return this.event.className;
  }
  get title(): string {
    return this.event.title;
  }
  get startDate(): string {
    return DateTimeHelper.parseDate(this.event.start)
  }

  get start(): string {
    return DateTimeHelper.parseTime(this.event.start)
  }
  get endDate(): string {
    return DateTimeHelper.parseDate(this.event.end)
  }
  get end(): string {
    return this.event.end ? DateTimeHelper.parseTime(this.event.end) : ''
  }

  get fullDate(): string {
    if (this.event.end)
      return `${this.start} - ${DateTimeHelper.parseTime(this.event.end)}`
    return this.start;
  }

  get isAppointment(): boolean {
    return this.event.type === AppointmentTypes.Appointment
      && this.event.appointment_state === AppointmentState.Draft;
  }

  get lblSettingButtonText(): string {
    return this.event.appointment_state === AppointmentState.Confirmed ? 'LBL_REVERT' : 'LBL_CONFIRM'
  }

  get coCanUpdate() {
    if (this.event.originId === "-1") return false;
    else if (this.event.type === AppointmentTypes.Appointment)
      return this.canUpdate && this.canUpdate.appointment;
    return this.canUpdate && this.canUpdate.event;
  }

  get coCanRemove() {
    if (this.event.originId === "-1") return false;
    else if (this.event.type === AppointmentTypes.Appointment)
      return this.canRemove && this.canRemove.appointment;
    return this.canRemove && this.canRemove.event;
  }

  get coDescription(): string {
    return this.event.description;
  }

  get coBlock(): string {
    return this.event.blockName || this.event.block.name;
  }

  get coICs() {
    return this.event.ics;
  }

  get eventItemStyle() {
    return location.pathname.indexOf("ticket") > -1
      ? { zIndex: 1001 }
      : null;
  }

  get shadow(): string {
    if (this.event.id === -1) {
      return 'event-shadow';
    } else return null
  }
  handleContainerClick() {
    this.dtMenu = true;
  }
  handleConvert: (event) => void;
  handleDelete: (event) => void;
  handleUpdate: (event) => void;


  mounted() {
    if (this.$route && this.$route.query.event_id) {
      this.handleOpenMenu(this.$route.query.event_id);
      this.$watch("$route.query", ({ event_id }) => {
        this.handleOpenMenu(event_id)
      });

      this.$watch("dtMenu", (value) => {
        if (!value && this.$route.query.event_id) {
          this.$router.replace({ query: {} })
        }
      })
    }

  }
  handleOpenMenu(event_id) {
    if (this.$route.fullPath.indexOf("agenda") > -1 && event_id) {
      if (event_id === this.event.originId) {
        this.dtMenu = true;
      }
    }
  }


}

export default AgendaEventItem;


// WEBPACK FOOTER //
// ./src/containers/agenda/components/agenda-event-item/index.ts